export default class SectionsRandomizer {
    
    static generateSections(randomizedSections, start, end) {
        var sections = [];
        let previousLanes = []; // Store lanes from the previous section
        const allPossibleLanes = this.generateAllPossibleLanes();

        const activeRulesPath = Math.floor(Math.random() * Object.keys(randomizedSections[0].randomizedRules).length);

        if(activeRulesPath === 0) {
            console.log("[SectionsRandomizer] Activating Rules Version A: colour, colour, shape, shape, colour, shape.");
        } else {
            console.log("[SectionsRandomizer] Activating Rules Version B: shape, shape, colour, colour, shape, colour.");
        }

        for (const randomConfig of randomizedSections) {
            const numSections = Math.floor(Math.random() * (randomConfig.rangeOfSections[1] - randomConfig.rangeOfSections[0] + 1)) + randomConfig.rangeOfSections[0];

            console.log("[SectionsRandomizer][Rule Block] Number of sections " + numSections + " from available range ["+ randomConfig.rangeOfSections[0] +" - "+ randomConfig.rangeOfSections[1] +"]");
            


            var speeds = [0, 1, 2, 3];
            var colors = [1, 2, 3, 4];
            var shapes = ["a", "b", "c", "d"];

            this.shuffleArray(speeds);
            this.shuffleArray(colors);
            this.shuffleArray(shapes);

            var ruleCharacters;
            if (randomConfig.randomizedRules[activeRulesPath] === "color") {
                // Numbers are leading
                ruleCharacters = colors;
                console.log("[SectionsRandomizer][Rule Block] Color rule applied ");
            } else {
                // Letters are leading
                ruleCharacters = shapes;
                console.log("[SectionsRandomizer][Rule Block] Shape rule applied ");
            }

            // this will link a rule character to a speed for this set of sections
            var ruleToSpeed = speeds.map((speed, index) => ({
                speed: speed,
                ruleCharacter: ruleCharacters[index]
            }));
            console.log("[SectionsRandomizer][Rule Block] Speed to Color/Shape \n" + ruleToSpeed.map(a => "Speed: " + a.speed + " -> Color/Shape: " +a.ruleCharacter).join("\n"));
            for (let i = 0; i < numSections; i++) {
                this.shuffleArray(ruleToSpeed, true);

                var availableLanes = allPossibleLanes.filter(lane => !previousLanes.includes(lane));
                this.shuffleArray(availableLanes);

                var lanes = [];
                var success = this.selectLanes(ruleToSpeed, availableLanes, lanes, []);

                if (!success) {
                    throw new Error("Failed to generate valid lanes");
                }

                sections.push({
                    speeds: ruleToSpeed.map(a => a.speed),
                    lanes: lanes.join(','),
                    action: i === 0 ? 'rulechange' : undefined // Optional action for the first section
                });

                previousLanes = [...lanes]; // Update previous lanes to avoid repetition in the next section
            }
        }

        const totalRangeMinOfSections = randomizedSections.reduce((total, config) => total + config.rangeOfSections[0], 0);
        const totalRangeMaxOfSections = randomizedSections.reduce((total, config) => total + config.rangeOfSections[1], 0);
        console.log("[SectionsRandomizer][Rule Block] Total Number of sections generated: " + sections.length + " from available range ["+ totalRangeMinOfSections +" - "+ totalRangeMaxOfSections +"]");

        if(sections.length > 0) {
            sections[sections.length - 1].action = "pre-finish";
            sections[sections.length - 1].marker = {"skin":"FinishTile", "position": -30};
        }
        
        if (start && start.length > 0) {
            sections = [...start, ...sections];
        }
        
        if (end && end.length > 0) {
            sections = [...sections, ...end];
        }
        return sections;
    }

    static selectLanes(ruleToSpeed, availableLanes, lanes, charactersToIgnore) {
        if (ruleToSpeed.length === 0) {
            return true;
        }

        const { speed, ruleCharacter } = ruleToSpeed[0];
        for (let i = 0; i < availableLanes.length; i++) {
            const matchedLane = availableLanes[i];
            if (matchedLane.includes(ruleCharacter) && !charactersToIgnore.some(char => matchedLane.includes(char))) {
                lanes.push(matchedLane);
                const charactersToRemove = matchedLane.split('');
                const newAvailableLanes = availableLanes.filter(lane =>
                    !charactersToRemove.some(char => lane.includes(char))
                );

                if (this.selectLanes(ruleToSpeed.slice(1), newAvailableLanes, lanes, [...charactersToIgnore, ...charactersToRemove])) {
                    return true;
                }

                // Backtrack in case the this matched lane doesn't lead to a valid solution
                lanes.pop();
            }
        }
        return false;
    }

    // Helper function to shuffle an array
    static shuffleArray(array, ensureNewValue = false) {
        const clonedArray = [...array];
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]]; // Swap elements
        }
        if (ensureNewValue && this.arraysAreEqual(array, clonedArray)) {
            this.shuffleArray(array, ensureNewValue);
        }
    }

    static arraysAreEqual(arr1, arr2) {
        return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
    }

    // Generates all possible lanes from 1a to 4d
    static generateAllPossibleLanes() {
        const colors = [1, 2, 3, 4];
        const shapes = ['a', 'b', 'c', 'd'];
        const allLanes = [];

        for (let color of colors) {
            for (let shape of shapes) {
                allLanes.push(`${color}${shape}`);
            }
        }
        return allLanes;
    }
}
